export const MIN_GLUCOSE_MMOL = 2;
export const MAX_GLUCOSE_MMOL = 30;

// Elfogadja a vesszős és pontos tizedes elválasztót is (magyar billentyűzet).
function parseGlucose(value: string): number {
  return parseFloat(value.replace(",", "."));
}

/**
 * Éhomi vércukor-validáció (mmol/l) a napló bejegyzés mezőjéhez. A mező
 * opcionális — üres érték érvényes. Magyar hibaüzenetet ad vissza, vagy
 * null-t, ha az érték érvényes (vagy üres).
 */
export function validateGlucose(value: number | string | ""): string | null {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const num = typeof value === "number" ? value : parseGlucose(value);

  if (Number.isNaN(num)) {
    return "Érvénytelen vércukorérték.";
  }

  if (num < MIN_GLUCOSE_MMOL || num > MAX_GLUCOSE_MMOL) {
    return `A vércukor ${MIN_GLUCOSE_MMOL} és ${MAX_GLUCOSE_MMOL} mmol/l között lehet.`;
  }

  if (Math.abs(Math.round(num * 10) - num * 10) > 1e-9) {
    return "A vércukor legfeljebb egy tizedesjegyet tartalmazhat.";
  }

  return null;
}
